export function getModelConfigPath({ modelPath }) {
  return modelPath;
}

export function setModelOptionsFormData(formData) {
  return formData;
}
